import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsPositionViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map